import PromoPlacementManager from '../services/PromoPlacementManager';

let isInitialized = false;

export const initPromoPlacement = () => {
    if (isInitialized) {
        return;
    }

    try {
        if (!window.appConfig || !window.appConfig.promoPlacements) {
            return;
        }

        if (!window.appConfig.promoPlacementsOwnerId) {
            console.error('[PromoPlacementsInit] ownerId not provided');
            return;
        }

        window.yaContextCb = window.yaContextCb || [];

        window.yaContextCb.push(() => {
            if (isInitialized) {
                return;
            }

            try {
                if (!window.appConfig?.promoPlacements || !window.appConfig?.promoPlacementsOwnerId) {
                    console.error('[PromoPlacementsInit] Missing config in callback');
                    return;
                }

                if (!PromoPlacementManager || typeof PromoPlacementManager.getInstance !== 'function') {
                    console.error('[PromoPlacementsInit] PromoPlacementManager not available');
                    return;
                }

                const manager = PromoPlacementManager.getInstance();
                if (!manager) {
                    console.error('[PromoPlacementsInit] Manager is null');
                    return;
                }

                manager.init(window.appConfig.promoPlacements, window.appConfig.promoPlacementsOwnerId);
                window.promoPlacementManager = manager;

                if (window.appConfig?.defaultTourCriteria?.countries?.[0]?.id && window.appConfig.promoPlacements.length > 0) {
                    const countryId = Number(window.appConfig.defaultTourCriteria.countries[0].id);

                    const hasPlacementsForCountry = window.appConfig.promoPlacements.some(
                        p => Number(p.countryId) === countryId
                    );

                    if (!hasPlacementsForCountry) {
                        isInitialized = true;
                        return;
                    }

                    manager.setCurrentCountryId(countryId);
                    manager.createPlacementsWhenContainersReady(countryId);
                }

                isInitialized = true;
            } catch (error) {
                console.error('[PromoPlacementsInit] Error in callback:', error);
            }
        });

    } catch (error) {
        console.error('[PromoPlacementsInit] Init failed:', error);
    }
};

export default {};
